import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "@design-system/Inputs/Button";
import HeaderLayout from "@app/components/Layouts/FullFrame/HeaderLayout";
import { useEditorContext } from "../hooks/useEditor";

export default function Header() {
    const { t } = useTranslation("EditDocument");
    const navigate = useNavigate();
    const { version } = useEditorContext();
    return (
        <HeaderLayout title={version?.document?.name || ""}>
            <Button variant="tonal" size="sm" onClick={() => navigate("../..")}>
                {t("close")}
            </Button>
        </HeaderLayout>
    );
}
